const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL
const apiVersionStr = '/api/v1'

export const URL = `${baseUrl}${apiVersionStr}`
